import { SpeakingSlotDto } from 'api/planning';
import { endsAfterMidnight } from '../../utils/endsAfterMidnight';

type SlotTime = Pick<SpeakingSlotDto, 'startTime' | 'endTime'>;

export const getSpeakingStructureTimeBounds = (
  slots: SlotTime[]
): { startTime?: string; endTime?: string } => {
  const overnightSlot = slots.find((slot) => endsAfterMidnight(slot.startTime, slot.endTime));

  if (overnightSlot) {
    let firstSlot = overnightSlot;
    let previousSlot = slots.find((slot) => slot.endTime === firstSlot.startTime);
    const visitedSlots = new Set<SlotTime>([firstSlot]);

    while (previousSlot && !visitedSlots.has(previousSlot)) {
      firstSlot = previousSlot;
      visitedSlots.add(firstSlot);
      previousSlot = slots.find((slot) => slot.endTime === firstSlot.startTime);
    }

    return { startTime: firstSlot.startTime, endTime: overnightSlot.endTime };
  }

  return {
    startTime: slots.map((slot) => slot.startTime).sort((a, b) => a.localeCompare(b))[0],
    endTime: slots.map((slot) => slot.endTime).sort((a, b) => a.localeCompare(b))[slots.length - 1],
  };
};
